export const hotelPages = [
	{
		id: 0,
		label: 'index',
		route: '',
	},
	{
		id: 1,
		label: 'accommodation',
		route: 'rooms',
	},
	{
		id: 2,
		label: 'restaurant',
		route: 'diningsandmeetings',
	},
	{
		id: 3,
		label: 'facility',
		route: 'amenities',
	},
	{
		id: 4,
		label: 'activity',
		route: 'activities',
	},
	{
		id: 5,
		label: 'location',
		route: 'directions',
	},
	{
		id: 6,
		label: 'news',
		route: 'promotions',
	},
];



// WEBPACK FOOTER //
// ./src/util/navi.js